import { FC } from 'react';
import {
  Stack,
  Tooltip,
  Box,
  Typography,
  Divider,
  ListItemText,
  MenuList,
  MenuItem,
  ListItemIcon,
  IconButton,
} from '@mui/material';
import { Close, Favorite, HeartBroken, MoreVertTwoTone } from '@mui/icons-material';

import { IconButtonDropdown } from '@cvt/components/ButtonDropdown';

import { useMajorCrud } from '../hooks/useMajorCrud';

export const MajorOptionsScheduled: FC<Majors.Major> = major => {

  return (
    <Stack direction="row" spacing={1}>
      <MajorOptionsMore {...major} />
    </Stack>
  );
};

export const MajorOptionsMore: FC<Majors.Major> = major => {

  const { likeMajor, unlikeMajor, ignoreMajor } = useMajorCrud();

  const optionsDisabled = [likeMajor.isPending, unlikeMajor.isPending, ignoreMajor.isPending].some(value => value); 

  return (
    <Box color="grey.500">
      <Tooltip title="More">
        <IconButtonDropdown
          buttonProps={{
            color: 'inherit',
          }}
          content={({ closeDropdown }) => (
            <Box>
              <Box bgcolor="secondary.light" px={2} py={1}>
                <Typography variant="h3">Options</Typography>
              </Box>
              <Divider/>
              <MenuList>
                {major.match.isFavourite ? (
                  <MenuItem onClick={() => [unlikeMajor.mutateAsync(major.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <HeartBroken fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unfavourite</ListItemText>
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => [likeMajor.mutateAsync(major.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <Favorite fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Favorite</ListItemText>
                  </MenuItem>
                )}
                <MenuItem onClick={() => [ignoreMajor.mutateAsync(major.id), closeDropdown()]} disabled={optionsDisabled}>
                  <ListItemIcon>
                    <Close fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Not interested</ListItemText>
                </MenuItem>
              </MenuList>
            </Box>
          )}
        >
          <MoreVertTwoTone/>
        </IconButtonDropdown>
      </Tooltip>
    </Box>
  );
};

export const MajorOptions: FC<Majors.Major> = major => {
  const { likeMajor, unlikeMajor, ignoreMajor } = useMajorCrud();

  const optionsDisabled = [likeMajor.isPending, unlikeMajor.isPending, ignoreMajor.isPending].some(value => value); 

  return (
    <>
      {major.match.isFavourite && (
        <IconButton onClick={() => unlikeMajor.mutateAsync(major.id)} color="error" disabled={optionsDisabled}>
          <Favorite fontSize="small" />
        </IconButton>
      )}
      <MajorOptionsMore {...major} />
    </>
  );
};
